// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-family: Arial, sans-serif;
}

/* Global styles for main content areas */
.szakjelentesek,
.home,
.reports,
.products,
[class*="page-"],
[class*="-container"] {
  padding-top: 0; /* Remove any top padding */
  margin-top: 0; /* Remove any top margin */
}

.home-title {
  text-align: center;
  margin: 0px 0 0 0px;
  font-weight: bold;
  font-size: 32px;
}

.reports,
.products {
  display: flex;
  height: 90vh;
  align-items: center;
  justify-content: center;
  font-size: 3rem;
}

.page-content {
  transition: margin-left 0.5s;
  margin-left: 0;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.page-content.active {
  margin-left: 300px; /* Megnövelt szélesség */
}

.page-content.responsive.active {
  margin-left: 0; /* Reszponzív módban nem tolja el a fő tartalmat */
}

/* Ensure all direct children of page-content take up full width */
.page-content > * {
  width: 100%;
}

.navbar {
  background-color: #41465C;
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 2rem;
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 1000;
}

.menu-bars {
  margin-left: 2rem;
  font-size: 2rem;
  background: none;
  color: white;
  display: flex;
  align-items: center; /* Középre igazítás vertikálisan */
}

.nav-menu {
  background-color: #242943;
  width: 300px; /* Megnövelt szélesség */
  height: 100vh;
  display: flex;
  justify-content: center;
  position: fixed;
  top: 0;
  left: -300px; /* Megnövelt szélesség */
  transition: 350ms;
  z-index: 999;
  overflow-y: auto;  /* Görgethetőség hozzáadása, ha a tartalom túl hosszú */
}

.nav-menu.active {
  left: 0;
}

.nav-menu.responsive {
  left: -300px; /* Reszponzív módban alapértelmezettként zárva van */
}

.nav-menu.responsive.active {
  left: 0; /* Reszponzív módban, ha aktív, megjelenik */
}

.nav-text {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 12px 0px 12px 16px; /* Növelt padding a térköz növelése érdekében */
  list-style: none;
  height: auto; /* Több soros tartalomhoz */
  white-space: normal;  /* Sortörés engedélyezése */
  word-wrap: break-word;  /* Hosszú szavak törése */
  overflow: visible;  /* Nem rejtjük el a hosszú szöveget */
}

.nav-text a {
  text-decoration: none;
  color: #f5f5f5;
  font-size: 16px;
  width: 95%;
  height: 100%;
  display: flex;
  align-items: center;
  padding: 10px 20px; /* Növelt padding, hogy vastagabbnak tűnjön a szövegdoboz */
  border-radius: 8px; /* Lekerekített sarkok */
}

.nav-text a:hover {
  background-color: #1a83ff;
}

.nav-text a.active {
  background-color: #1a83ff; /* Világos kék háttérszín az aktív elemhez */
  border: 3px solid #0a67c1; /* Vastagabb szegély az aktív elemhez */
  padding: 12px 24px; /* További padding, hogy vastagabbnak tűnjön a szövegdoboz */
}

.nav-menu-items {
  width: 100%;
}

.navbar-toggle {
  background-color: #242943;
  width: 100%;
  height: 60px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

span {
  margin-left: 16px;
}

.user-info {
  display: flex;
  align-items: center;
  justify-content: flex-end; /* Jobbra igazítás */
  gap: 12px;
  color: #f5f5f5;
  margin-right: 2rem; /* Megfelelő távolság a jobb széltől */
}

.user-info i {
  font-size: 2rem;
  cursor: pointer; /* Kattinthatóság biztosítása */
  margin-left: 0;
  margin-top: 0;
  border: none; /* Keret eltávolítása */
  padding: 0;
  display: flex;
  align-items: center; /* Vertikálisan középre helyezés */
}

.role-switch-button,
.user-info .logout-button {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  margin: 0 !important;
  padding: 0 2px !important;
  line-height: 1;
}

.user-details {
  display: flex;
  flex-direction: column;
  align-items: flex-end; /* Jobbra igazítás */
  justify-content: center;
  height: 40px;
}

.user-details span {
  margin-bottom: 5px;
  color: #f5f5f5;
  line-height: 1; /* A szöveg helyes vertikális középre igazítása */
}

.user-info i:hover {
  opacity: 0.8; /* Hover effekt */
}

.user-info i:focus {
  outline: none; /* Fókusz keret eltávolítása */
}

.nav-sub-text {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 12px 0px 12px 16px; /* Növelt padding a térköz növeléséhez */
  list-style: none;
  height: auto; /* Több soros tartalomhoz */
  white-space: normal;
  word-wrap: break-word;
  overflow: visible;
}

.nav-sub-text a {
  text-decoration: none;
  color: #f5f5f5;
  font-size: 16px; /* Azonos betűméret, mint a nav-text */
  width: 95%;
  height: 100%;
  display: flex;
  align-items: center;
  padding: 10px 20px; /* Növelt padding, hogy vastagabbnak tűnjön a szövegdoboz */
  border-radius: 8px; /* Lekerekített sarkok */
}

.nav-sub-text a:hover {
  background-color: #1a83ff; /* Hover háttérszín azonos a nav-text stílusával */
}

.nav-sub-text a.active {
  background-color: #1a83ff; /* Világos kék háttérszín az aktív elemhez */
  border: 3px solid #0a67c1; /* Vastagabb szegély az aktív elemhez */
  padding: 12px 24px; /* További padding, hogy vastagabbnak tűnjön a szövegdoboz */
}

.nav-sub-text i.material-icons {
  font-size: 1.75rem;
  margin-right: 8px;
}

/* Form container styles */
.form-container {
  width: calc(100% - 40px);
  margin: 10px auto;
  padding: 20px;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
}

/* General button styles */
button {
  background-color: #50ADC9;
  color: white;
  border: none;
  padding: 10px 20px;
  font-size: 16px;
  border-radius: 5px;
  cursor: pointer;
  margin: 10px 5px;
  transition: background-color 0.3s ease;
}

button:hover {
  background-color: #4198b1;
}

.szak-button-container {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.szak-button {
  margin: 0 10px;
}

.button-container-left,
.button-container-right {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.button-container-left button {
  margin-left: 0;
}

.button-container-right button {
  margin-right: 0;
}

.nav-text i.material-icons,
.nav-sub-text i.material-icons {
  margin-right: 8px;
}

.logout-button {
  margin-top: 5px !important;
  padding-bottom: 5px !important;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,8BAA8B;AAChC;;AAEA,yCAAyC;AACzC;;;;;;EAME,cAAc,EAAE,2BAA2B;EAC3C,aAAa,EAAE,0BAA0B;AAC3C;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB,EAAE,wBAAwB;AAC9C;;AAEA;EACE,cAAc,EAAE,kDAAkD;AACpE;;AAEA,kEAAkE;AAClE;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,WAAW;EACX,MAAM;EACN,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,mBAAmB,EAAE,kCAAkC;AACzD;;AAEA;EACE,yBAAyB;EACzB,YAAY,EAAE,wBAAwB;EACtC,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,MAAM;EACN,YAAY,EAAE,wBAAwB;EACtC,iBAAiB;EACjB,YAAY;EACZ,gBAAgB,GAAG,uDAAuD;AAC5E;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,YAAY,EAAE,oDAAoD;AACpE;;AAEA;EACE,OAAO,EAAE,4CAA4C;AACvD;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,2BAA2B,EAAE,+CAA+C;EAC5E,gBAAgB;EAChB,YAAY,EAAE,2BAA2B;EACzC,mBAAmB,GAAG,2BAA2B;EACjD,qBAAqB,GAAG,yBAAyB;EACjD,iBAAiB,GAAG,qCAAqC;AAC3D;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,UAAU;EACV,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB,EAAE,2DAA2D;EAC/E,kBAAkB,EAAE,wBAAwB;AAC9C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB,EAAE,4CAA4C;EACvE,yBAAyB,EAAE,uCAAuC;EAClE,kBAAkB,EAAE,4DAA4D;AAClF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB,EAAE,oBAAoB;EAC/C,SAAS;EACT,cAAc;EACd,kBAAkB,EAAE,sCAAsC;AAC5D;;AAEA;EACE,eAAe;EACf,eAAe,EAAE,+BAA+B;EAChD,cAAc;EACd,aAAa;EACb,YAAY,EAAE,uBAAuB;EACrC,UAAU;EACV,aAAa;EACb,mBAAmB,EAAE,kCAAkC;AACzD;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,oBAAoB;EACpB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB,EAAE,oBAAoB;EAC3C,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,cAAc,EAAE,iDAAiD;AACnE;;AAEA;EACE,YAAY,EAAE,iBAAiB;AACjC;;AAEA;EACE,aAAa,EAAE,8BAA8B;AAC/C;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,2BAA2B,EAAE,wCAAwC;EACrE,gBAAgB;EAChB,YAAY,EAAE,2BAA2B;EACzC,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,eAAe,EAAE,sCAAsC;EACvD,UAAU;EACV,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB,EAAE,2DAA2D;EAC/E,kBAAkB,EAAE,wBAAwB;AAC9C;;AAEA;EACE,yBAAyB,EAAE,kDAAkD;AAC/E;;AAEA;EACE,yBAAyB,EAAE,4CAA4C;EACvE,yBAAyB,EAAE,uCAAuC;EAClE,kBAAkB,EAAE,4DAA4D;AAClF;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,0BAA0B;AAC1B;EACE,wBAAwB;EACxB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA,0BAA0B;AAC1B;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,8BAA8B;AAChC","sourcesContent":["* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  font-family: Arial, sans-serif;\n}\n\n/* Global styles for main content areas */\n.szakjelentesek,\n.home,\n.reports,\n.products,\n[class*=\"page-\"],\n[class*=\"-container\"] {\n  padding-top: 0; /* Remove any top padding */\n  margin-top: 0; /* Remove any top margin */\n}\n\n.home-title {\n  text-align: center;\n  margin: 0px 0 0 0px;\n  font-weight: bold;\n  font-size: 32px;\n}\n\n.reports,\n.products {\n  display: flex;\n  height: 90vh;\n  align-items: center;\n  justify-content: center;\n  font-size: 3rem;\n}\n\n.page-content {\n  transition: margin-left 0.5s;\n  margin-left: 0;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.page-content.active {\n  margin-left: 300px; /* Megnövelt szélesség */\n}\n\n.page-content.responsive.active {\n  margin-left: 0; /* Reszponzív módban nem tolja el a fő tartalmat */\n}\n\n/* Ensure all direct children of page-content take up full width */\n.page-content > * {\n  width: 100%;\n}\n\n.navbar {\n  background-color: #41465C;\n  height: 60px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 2rem;\n  position: fixed;\n  width: 100%;\n  top: 0;\n  z-index: 1000;\n}\n\n.menu-bars {\n  margin-left: 2rem;\n  font-size: 2rem;\n  background: none;\n  color: white;\n  display: flex;\n  align-items: center; /* Középre igazítás vertikálisan */\n}\n\n.nav-menu {\n  background-color: #242943;\n  width: 300px; /* Megnövelt szélesség */\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  position: fixed;\n  top: 0;\n  left: -300px; /* Megnövelt szélesség */\n  transition: 350ms;\n  z-index: 999;\n  overflow-y: auto;  /* Görgethetőség hozzáadása, ha a tartalom túl hosszú */\n}\n\n.nav-menu.active {\n  left: 0;\n}\n\n.nav-menu.responsive {\n  left: -300px; /* Reszponzív módban alapértelmezettként zárva van */\n}\n\n.nav-menu.responsive.active {\n  left: 0; /* Reszponzív módban, ha aktív, megjelenik */\n}\n\n.nav-text {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  padding: 12px 0px 12px 16px; /* Növelt padding a térköz növelése érdekében */\n  list-style: none;\n  height: auto; /* Több soros tartalomhoz */\n  white-space: normal;  /* Sortörés engedélyezése */\n  word-wrap: break-word;  /* Hosszú szavak törése */\n  overflow: visible;  /* Nem rejtjük el a hosszú szöveget */\n}\n\n.nav-text a {\n  text-decoration: none;\n  color: #f5f5f5;\n  font-size: 16px;\n  width: 95%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  padding: 10px 20px; /* Növelt padding, hogy vastagabbnak tűnjön a szövegdoboz */\n  border-radius: 8px; /* Lekerekített sarkok */\n}\n\n.nav-text a:hover {\n  background-color: #1a83ff;\n}\n\n.nav-text a.active {\n  background-color: #1a83ff; /* Világos kék háttérszín az aktív elemhez */\n  border: 3px solid #0a67c1; /* Vastagabb szegély az aktív elemhez */\n  padding: 12px 24px; /* További padding, hogy vastagabbnak tűnjön a szövegdoboz */\n}\n\n.nav-menu-items {\n  width: 100%;\n}\n\n.navbar-toggle {\n  background-color: #242943;\n  width: 100%;\n  height: 60px;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n\nspan {\n  margin-left: 16px;\n}\n\n.user-info {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end; /* Jobbra igazítás */\n  gap: 12px;\n  color: #f5f5f5;\n  margin-right: 2rem; /* Megfelelő távolság a jobb széltől */\n}\n\n.user-info i {\n  font-size: 2rem;\n  cursor: pointer; /* Kattinthatóság biztosítása */\n  margin-left: 0;\n  margin-top: 0;\n  border: none; /* Keret eltávolítása */\n  padding: 0;\n  display: flex;\n  align-items: center; /* Vertikálisan középre helyezés */\n}\n\n.role-switch-button,\n.user-info .logout-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 40px;\n  margin: 0 !important;\n  padding: 0 2px !important;\n  line-height: 1;\n}\n\n.user-details {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end; /* Jobbra igazítás */\n  justify-content: center;\n  height: 40px;\n}\n\n.user-details span {\n  margin-bottom: 5px;\n  color: #f5f5f5;\n  line-height: 1; /* A szöveg helyes vertikális középre igazítása */\n}\n\n.user-info i:hover {\n  opacity: 0.8; /* Hover effekt */\n}\n\n.user-info i:focus {\n  outline: none; /* Fókusz keret eltávolítása */\n}\n\n.nav-sub-text {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  padding: 12px 0px 12px 16px; /* Növelt padding a térköz növeléséhez */\n  list-style: none;\n  height: auto; /* Több soros tartalomhoz */\n  white-space: normal;\n  word-wrap: break-word;\n  overflow: visible;\n}\n\n.nav-sub-text a {\n  text-decoration: none;\n  color: #f5f5f5;\n  font-size: 16px; /* Azonos betűméret, mint a nav-text */\n  width: 95%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  padding: 10px 20px; /* Növelt padding, hogy vastagabbnak tűnjön a szövegdoboz */\n  border-radius: 8px; /* Lekerekített sarkok */\n}\n\n.nav-sub-text a:hover {\n  background-color: #1a83ff; /* Hover háttérszín azonos a nav-text stílusával */\n}\n\n.nav-sub-text a.active {\n  background-color: #1a83ff; /* Világos kék háttérszín az aktív elemhez */\n  border: 3px solid #0a67c1; /* Vastagabb szegély az aktív elemhez */\n  padding: 12px 24px; /* További padding, hogy vastagabbnak tűnjön a szövegdoboz */\n}\n\n.nav-sub-text i.material-icons {\n  font-size: 1.75rem;\n  margin-right: 8px;\n}\n\n/* Form container styles */\n.form-container {\n  width: calc(100% - 40px);\n  margin: 10px auto;\n  padding: 20px;\n  background-color: #fff;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  border-radius: 8px;\n}\n\n/* General button styles */\nbutton {\n  background-color: #50ADC9;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  font-size: 16px;\n  border-radius: 5px;\n  cursor: pointer;\n  margin: 10px 5px;\n  transition: background-color 0.3s ease;\n}\n\nbutton:hover {\n  background-color: #4198b1;\n}\n\n.szak-button-container {\n  display: flex;\n  justify-content: center;\n  margin-top: 20px;\n}\n\n.szak-button {\n  margin: 0 10px;\n}\n\n.button-container-left,\n.button-container-right {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.button-container-left button {\n  margin-left: 0;\n}\n\n.button-container-right button {\n  margin-right: 0;\n}\n\n.nav-text i.material-icons,\n.nav-sub-text i.material-icons {\n  margin-right: 8px;\n}\n\n.logout-button {\n  margin-top: 5px !important;\n  padding-bottom: 5px !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
